interface Properties {
  className?: string;
  onClick?: () => void;
}

const Item: React.FC<Properties> = ({ className, ...props }) => {
  return <li className={`p-4 rounded-lg ${className ?? ""}`} {...props} />;
};

export default Item;
